import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.3568 4.19057L7.19013 0.533163C7.6935 0.253513 8.30557 0.253513 8.80894 0.533163L14.6423 4.19057C15.1714 4.48452 15.5069 5.04267 15.4733 5.64701C15.2975 8.80985 14.1212 13.3684 8.58109 15.6864C8.20936 15.8419 7.78971 15.8419 7.41798 15.6864C1.8779 13.3684 0.701617 8.80985 0.525749 5.64701C0.492144 5.04267 0.827689 4.48452 1.3568 4.19057ZM5.08317 8.00002C5.08317 7.53978 5.45627 7.16669 5.9165 7.16669H7.1665V5.91669C7.1665 5.45645 7.5396 5.08335 7.99984 5.08335C8.46007 5.08335 8.83317 5.45645 8.83317 5.91669V7.16669H10.0832C10.5434 7.16669 10.9165 7.53978 10.9165 8.00002C10.9165 8.46026 10.5434 8.83335 10.0832 8.83335H8.83317V10.0834C8.83317 10.5436 8.46007 10.9167 7.99984 10.9167C7.5396 10.9167 7.1665 10.5436 7.1665 10.0834V8.83335H5.9165C5.45627 8.83335 5.08317 8.46026 5.08317 8.00002Z",
  fill: "white"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}